import { render, staticRenderFns } from "./PreferencesFriendTypePage.vue?vue&type=template&id=4348147d"
import script from "./PreferencesFriendTypePage.vue?vue&type=script&lang=js"
export * from "./PreferencesFriendTypePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports